
import React from "react";
import { IProfile } from "../../../../services";
import { i18nManager } from "../../../../i18n";
import { NavLink } from "react-router-dom";

function Configurations() {

    const labels = i18nManager.Labels.dashboard.ploutous.configurations;

    return (<div className="charon-messages">
        <div className="management">
            <div className="plou-configurations">
                <div className="plou-configs">
                    <span>{labels.platform_config}</span>
                    <div>
                        <NavLink to={{ pathname: "/dashboard/finance/configurations/platform/configs", search: window.location.search }}>
                            <span>{labels.configurations}</span>
                        </NavLink>
                    </div>
                </div>
                <div className="plou-configs">
                    <span>{labels.countries_config}</span>
                    <div>
                        <NavLink to={{ pathname: "/dashboard/finance/configurations/countries/configs", search: window.location.search }}>
                            <span>{labels.configurations}</span>
                        </NavLink>
                        <NavLink to={{ pathname: "/dashboard/finance/configurations/countries/mappings", search: window.location.search }}>
                            <span>{labels.mappings}</span>
                        </NavLink>
                    </div>
                </div>
                <div className="plou-configs">
                    <span>{labels.services_config}</span>
                    <div>
                        <NavLink to={{ pathname: "/dashboard/finance/configurations/services/configs", search: window.location.search }}>
                            <span>{labels.configurations}</span>
                        </NavLink>
                        <NavLink to={{ pathname: "/dashboard/finance/configurations/services/mappings", search: window.location.search }}>
                            <span>{labels.mappings}</span>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    </div>);
}

export default Configurations;
